import styled from '@emotion/styled';
import { rem } from 'polished';

export const UtilityCardsHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: ${rem('48px')};
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    display: none;
  }
`;

export const UtilityCardsGrid = styled.div`
  display: flex;
  gap: ${rem('20px')};
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;

  > * {
    width: ${rem('385px')};
    height: ${rem('152px')};
    flex-shrink: 0;
  }
  [data-component-name*='LinkWithIcon'] {
    [data-component-name*='Icon'] {
      display: none;
    }
  }
`;
